import axios from 'axios';

function getCompanySelectorOptions() {
  const selector = document.getElementById('company_selector');
  if (!selector) {
    return [];
  }

  return Array.from(selector.options).map((opt) => ({
    id: String(opt.value),
    name: (opt.textContent || '').trim(),
  }));
}

function currentCompanyId() {
  if (window.companyId != null && window.companyId !== '') {
    return String(window.companyId);
  }

  const selector = document.getElementById('company_selector');
  return selector ? String(selector.value) : '';
}

function cleanUrlWithoutCompanyParam() {
  const params = new URLSearchParams(window.location.search);
  params.delete('company');
  const query = params.toString();

  return window.location.pathname + (query ? `?${query}` : '') + window.location.hash;
}

function stripCompanyParamInPlace() {
  window.history.replaceState(null, '', cleanUrlWithoutCompanyParam());
}

/**
 * When a brief link includes ?company=, switch to that company if the user has
 * access. Reloads after switching; strips the param when already correct.
 * Brief, share, and workroom pages also switch on the server from the brief's
 * own company, so links do not need this param.
 */
export async function ensureBriefCompanyContext() {
  if (typeof window === 'undefined') {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  const targetCompanyId = (params.get('company') || '').trim();
  if (!targetCompanyId) {
    const activeCompanyId = currentCompanyId();
    if (activeCompanyId) {
      localStorage.setItem('selected-company-id', activeCompanyId);
    }
    return;
  }

  const activeCompanyId = currentCompanyId();
  if (targetCompanyId === activeCompanyId) {
    stripCompanyParamInPlace();
    return;
  }

  const companies = getCompanySelectorOptions();
  if (companies.length === 0) {
    stripCompanyParamInPlace();
    return;
  }

  const hasAccess = companies.some((company) => company.id === targetCompanyId);
  if (!hasAccess) {
    stripCompanyParamInPlace();
    return;
  }

  const token = document.querySelector('input[name="_token"]')?.value;

  try {
    await axios.post('/change_company', {
      company_selector: targetCompanyId,
      _token: token,
    });
    localStorage.setItem('selected-company-id', targetCompanyId);
    window.location.replace(cleanUrlWithoutCompanyParam());
  } catch {
    stripCompanyParamInPlace();
  }
}
